export function positiveIntegerValidator(number) {
  if (!number || number < 0) return "Number should be greater than 0";
  return "";
}
